import React from 'react';
import { Logo } from '../ui/Logo';
interface BrandLogoProps {
  /** Logotipo propio de la empresa. Si no existe, se usa el logo del Sistema AVA. */
  src?: string;
  size?: number;
  /**
   * Altura en móvil. Si no se indica (o es 0) se usa la misma altura que en
   * escritorio: `mobileSize ?? size`. Nunca se oculta el logotipo por no tener
   * un valor propio para móvil.
   */
  mobileSize?: number;
  showWordmark?: boolean;
  alt?: string;
  className?: string;
  /**
   * Nombre de la empresa. Si no hay logotipo propio se muestra este nombre en
   * lugar del identificador de Sistema AVA, para que la landing de un cliente
   * nunca luzca una marca ajena.
   */
  fallbackName?: string;
}

/**
 * Punto único donde se resuelve el logotipo mostrado en toda la plataforma:
 * sidebar, dashboard, landings, formularios, footer y página de gracias.
 *
 * La altura viaja como variables CSS (`--logo-h` / `--logo-h-m`) sobre UN SOLO
 * elemento, en lugar de duplicar el logotipo en dos `<span>` con `hidden` /
 * `sm:hidden`. Así no existe ninguna combinación de clases que pueda dejar el
 * logotipo oculto en móvil, que era la causa de la regresión.
 */
export function BrandLogo({
  src,
  size = 28,
  mobileSize,
  showWordmark = true,
  alt = 'Logotipo',
  className = '',
  fallbackName
}: BrandLogoProps) {
  const desktop = Math.round(size * 1.5);
  const mobile = mobileSize && mobileSize > 0 ? Math.round(mobileSize * 1.5) : desktop;
  if (src) {
    return <img src={src} alt={alt} style={{
      '--logo-h': `${desktop}px`,
      '--logo-h-m': `${mobile}px`
    } as React.CSSProperties} className={`ava-brand-logo w-auto max-w-[190px] object-contain object-left sm:max-w-[240px] ${className}`} data-id="element-1039" data-mp="3qbibz7rw92so" />;
  }
  if (fallbackName && fallbackName.trim() !== '') {
    return <span style={{
      fontSize: Math.max(15, Math.round((mobileSize && mobileSize > 0 ? mobileSize : size) * 0.62))
    }} className={`font-semibold tracking-tight text-navy ${className}`} data-id="element-1040" data-mp="1akm2fzwbq1p2">
        {fallbackName}
      </span>;
  }
  return <Logo size={size} showWordmark={showWordmark} className={className} data-id="element-1041" data-mp="1e31p3334irmt" />;
}